const Suspense = ({ fallback, loading, children }) => {
  if (loading) return fallback;
  return children;
};

export default Suspense;
